module.exports = __webpack_public_path__ + "static/media/w_b_12.0d2edfe1.png";